// extracted by mini-css-extract-plugin
export default {"wrapper":"CountDown_wrapper","notice":"CountDown_notice","withoutIcon":"CountDown_withoutIcon","largeWrapper":"CountDown_largeWrapper"};